import {useCallback, useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import WatchTicketMutation from '../../../../../mutations/ticketing/tickets/watchTicketMutation';
import UnwatchTicketMutation from '../../../../../mutations/ticketing/tickets/unwatchTicketMutation';

interface Options {
	onCompleted?: () => void;
	onError?: (error: Error) => void;
}

export function useWatchTicket(options?: Options) {
	const [inFlight, setInFlight] = useState(false);

	const watch = useCallback(
		(ticketId: string) => {
			setInFlight(true);
			commitTicketingMutation(
				WatchTicketMutation,
				{ticketId},
				() => {
					setInFlight(false);
					options?.onCompleted?.();
				},
				error => {
					setInFlight(false);
					options?.onError?.(error instanceof Error ? error : new Error(String(error)));
				}
			);
		},
		[options]
	);

	const unwatch = useCallback(
		(ticketId: string) => {
			setInFlight(true);
			commitTicketingMutation(
				UnwatchTicketMutation,
				{ticketId},
				() => {
					setInFlight(false);
					options?.onCompleted?.();
				},
				error => {
					setInFlight(false);
					options?.onError?.(error instanceof Error ? error : new Error(String(error)));
				}
			);
		},
		[options]
	);

	return {watch, unwatch, inFlight};
}
